// extracted by mini-css-extract-plugin
export default {"main_div":"LoadingEffect_main_div__Sakjh","center_div":"LoadingEffect_center_div__jCSY4","swif":"LoadingEffect_swif__B9DZS"};